(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		//if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-campaign-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tickr-campaign-buy')) {
    customElements.define('tickr-campaign-buy', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.reviewLink = this.querySelector('[data-tc-review-link]');
        if (this.reviewLink) {
          const updateReviewLink = () => {
            const wall = this.findReviewWall();
            this.reviewLink.setAttribute('href', wall ? '#' + wall.id : this.reviewLink.dataset.reviewFallback);
          };
          this.reviewLink.addEventListener('click', (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const wall = this.findReviewWall();
            if (!wall) {
              updateReviewLink();
              return;
            }
            event.preventDefault();
            wall.focus({ preventScroll: true });
            wall.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
            history.replaceState(history.state, '', '#' + wall.id);
          }, { signal: this.controller.signal });
          document.addEventListener('shopify:section:load', updateReviewLink, { signal: this.controller.signal });
          document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateReviewLink), { signal: this.controller.signal });
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateReviewLink, { once: true, signal: this.controller.signal });
          } else {
            updateReviewLink();
          }
        }
        this.idInput = this.querySelector('[data-tc-variant-id]');
        this.variantGroup = this.querySelector('[data-tc-variants]');
        this.fallback = this.querySelector('[data-tc-fallback]');
        this.select = this.querySelector('[data-tc-select]');
        this.total = this.querySelector('[data-tc-total]');
        this.price = this.querySelector('[data-tc-price]');
        this.compare = this.querySelector('[data-tc-compare]');
        this.availability = this.querySelector('[data-tc-availability]');
        this.add = this.querySelector('[data-tc-add]');
        this.addLabel = this.querySelector('[data-tc-add-label]');
        const selected = this.querySelector('[data-tc-variant-choice]:checked');
        if (!this.idInput || !this.add || !selected) return;

        this.querySelectorAll('[data-tc-variant-choice]').forEach((input) => {
          input.addEventListener('change', () => this.updateVariant(input), { signal: this.controller.signal });
        });
        this.updateVariant(selected);
        this.idInput.disabled = false;
        this.select.disabled = true;
        this.fallback.hidden = true;
        this.variantGroup.disabled = false;
        this.variantGroup.hidden = false;
        this.total.hidden = false;
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      findReviewWall() {
        return [...document.querySelectorAll('[data-tickr-review-wall]')].find((wall) =>
          wall.dataset.productId === this.reviewLink.dataset.reviewProductId && wall.isConnected && wall.getClientRects().length
        );
      }

      updateVariant(input) {
        const available = input.dataset.available === 'true';
        this.idInput.value = input.value;
        this.select.value = input.value;
        this.price.textContent = input.dataset.price;
        this.compare.textContent = input.dataset.comparePrice;
        this.compare.hidden = !input.dataset.comparePrice;
        this.availability.hidden = available;
        this.add.disabled = !available;
        this.addLabel.textContent = available ? this.add.dataset.availableLabel : this.add.dataset.soldOutLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tickr-help-center')) {
    customElements.define('tickr-help-center', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.query = this.querySelector('[data-help-query]');
        this.form = this.querySelector('[data-help-search]');
        this.resetButton = this.querySelector('[data-help-reset]');
        this.status = this.querySelector('[data-help-status]');
        this.empty = this.querySelector('[data-help-empty]');
        this.cards = Array.from(this.querySelectorAll('[data-help-card]'));
        this.groups = Array.from(this.querySelectorAll('[data-help-group]'));
        this.categories = Array.from(this.querySelectorAll('[data-help-category]'));
        this.activeCategory = 'all';
        this.form.hidden = this.cards.length === 0;
        this.form.addEventListener('submit', event => event.preventDefault(), options);
        this.query.addEventListener('input', () => this.filter(), options);
        this.form.addEventListener('reset', event => { event.preventDefault(); this.clear(); }, options);
        this.querySelector('[data-help-clear]').addEventListener('click', () => this.clear(), options);
        this.categories.forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activeCategory = link.dataset.helpCategory;
          this.filter();
        }, options));
        this.addEventListener('shopify:block:select', event => {
          this.clear(false);
          event.target.closest('[data-help-card]')?.scrollIntoView({ block: 'nearest' });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      normalize(value) {
        return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('en').trim();
      }
      clear(focus = true) {
        this.query.value = '';
        this.activeCategory = 'all';
        this.filter();
        if (focus) this.query.focus();
      }
      filter() {
        const terms = this.normalize(this.query.value).split(/\s+/).filter(Boolean);
        let count = 0;
        this.cards.forEach(card => {
          const categoryMatches = this.activeCategory === 'all' || card.dataset.category === this.activeCategory;
          const text = this.normalize(card.dataset.search);
          card.hidden = !categoryMatches || !terms.every(term => text.includes(term));
          if (!card.hidden) count++;
        });
        this.groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-help-card]')).some(card => !card.hidden); });
        this.categories.forEach(link => {
          if (link.dataset.helpCategory === this.activeCategory) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.resetButton.hidden = terms.length === 0 && this.activeCategory === 'all';
        this.empty.hidden = count !== 0;
        this.status.hidden = false;
        this.status.textContent = (count === 1 ? this.status.dataset.one : this.status.dataset.many).replace('[count]', String(count));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-home-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tickr-home-buy')) {
    customElements.define('tickr-home-buy', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-buy-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-buy-thumbnail]')];
        this.stage = this.querySelector('.tickr-home-buy__stage');
        this.swipeStart = null;
        this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (this.index < 0) this.index = 0;
        this.querySelectorAll('[data-buy-gallery-step]').forEach((button) => {
          button.addEventListener('click', () => this.showSlide(this.index + Number(button.dataset.buyGalleryStep)));
        });
        this.thumbnails.forEach((button) => {
          button.addEventListener('click', () => this.showSlide(Number(button.dataset.buyThumbnail)));
        });
        this.querySelectorAll('[data-buy-variant-choice]').forEach((input) => {
          input.addEventListener('change', () => this.updateVariant(input));
        });
        if (this.stage) {
          this.stage.addEventListener('pointerdown', (event) => this.startSwipe(event));
          this.stage.addEventListener('pointerup', (event) => this.finishSwipe(event));
          this.stage.addEventListener('pointercancel', (event) => this.cancelSwipe(event));
          this.stage.addEventListener('dragstart', (event) => event.preventDefault());
        }
      }

      showSlide(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.thumbnails.forEach((thumbnail) => {
          const active = Number(thumbnail.dataset.buyThumbnail) === this.index;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', String(active));
        });
        const activeSlide = this.slides[this.index];
        activeSlide.classList.remove('is-entering');
        void activeSlide.offsetWidth;
        activeSlide.classList.add('is-entering');
      }

      startSwipe(event) {
        if (event.button !== 0) return;
        this.swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stage.classList.add('is-dragging');
        this.stage.setPointerCapture(event.pointerId);
      }

      finishSwipe(event) {
        if (!this.swipeStart || event.pointerId !== this.swipeStart.id) return;
        const distanceX = event.clientX - this.swipeStart.x;
        const distanceY = event.clientY - this.swipeStart.y;
        this.cancelSwipe(event);
        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        this.showSlide(this.index + (distanceX < 0 ? 1 : -1));
      }

      cancelSwipe(event) {
        if (!this.swipeStart || event.pointerId !== this.swipeStart.id) return;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        this.swipeStart = null;
        this.stage.classList.remove('is-dragging');
      }

      updateVariant(input) {
        const idInput = this.querySelector('[data-buy-variant-id]');
        const addButton = this.querySelector('[data-buy-add-button]');
        const addLabel = this.querySelector('[data-buy-add-label]');
        const price = this.querySelector('[data-buy-product-price]');
        const compare = this.querySelector('[data-buy-product-compare]');
        const saving = this.querySelector('[data-buy-saving]');
        const savingsPercentage = this.querySelector('[data-buy-savings-percentage]');
        const available = input.dataset.available === 'true';
        const savings = Number(input.dataset.savings || 0);
        idInput.value = input.dataset.variantId;
        price.textContent = input.dataset.price;
        compare.textContent = input.dataset.comparePrice;
        compare.hidden = !input.dataset.comparePrice;
        saving.setAttribute('aria-hidden', String(savings <= 0));
        savingsPercentage.textContent = savings + '%';
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.availableLabel || 'Add to cart' : addButton.dataset.soldOutLabel || 'Sold out';
        if (input.dataset.mediaId) {
          const mediaIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === input.dataset.mediaId);
          if (mediaIndex >= 0) this.showSlide(mediaIndex);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.dataset.variantId);
        window.history.replaceState({}, '', url);
      }
    });
  }
  (() => {
    const findReviewWall = (link) => [...document.querySelectorAll('[data-tickr-review-wall]')].find((wall) =>
      wall.dataset.productId === link.dataset.reviewProductId && wall.isConnected && wall.getClientRects().length
    );

    const updateReviewLinks = () => {
      document.querySelectorAll('[data-buy-reviews-link]').forEach((link) => {
        const wall = findReviewWall(link);
        link.setAttribute('href', wall ? '#' + wall.id : link.dataset.reviewFallback);
      });
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('[data-buy-reviews-link]');
      if (!link) return;
      const wall = findReviewWall(link);
      if (!wall) {
        link.setAttribute('href', link.dataset.reviewFallback);
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      wall.focus({ preventScroll: true });
      wall.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start'
      });
      history.replaceState(history.state, '', '#' + wall.id);
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateReviewLinks, { once: true });
    } else {
      updateReviewLinks();
    }
    document.addEventListener('shopify:section:load', updateReviewLinks);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateReviewLinks));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = document.querySelectorAll('.tm-reveal:not(.is-visible)');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    revealItems.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-home-portfolio-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const switcherCleanups = new WeakMap();

    const mountPortfolioSwitcher = (root) => {
      if (!root || switcherCleanups.has(root)) return;

      const switches = Array.from(root.querySelectorAll('[data-portfolio-switch]'));
      const panels = Array.from(root.querySelectorAll('[data-portfolio-panel]'));
      const visual = root.querySelector('.tickr-portfolio-switcher__visual');
      const events = new AbortController();
      let autoplayTimer;

      const stopAutoplay = () => {
        clearInterval(autoplayTimer);
        autoplayTimer = undefined;
        visual?.setAttribute('aria-live', 'polite');
      };

      const activate = (targetId) => {
        switches.forEach((control) => {
          control.setAttribute('aria-checked', String(control.dataset.portfolioSwitch === targetId));
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.portfolioPanel === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
        });
      };

      switches.forEach((control) => {
        control.addEventListener('click', () => {
          stopAutoplay();
          activate(control.dataset.portfolioSwitch);
        }, { signal: events.signal });
      });

      root.addEventListener('focusin', stopAutoplay, { signal: events.signal });

      const cleanup = () => {
        stopAutoplay();
        events.abort();
        switcherCleanups.delete(root);
        delete root.dataset.portfolioSwitcherMounted;
      };

      switcherCleanups.set(root, cleanup);
      root.dataset.portfolioSwitcherMounted = 'true';

      if (switches.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        visual?.setAttribute('aria-live', 'off');
        autoplayTimer = setInterval(() => {
          if (!root.isConnected) {
            cleanup();
            return;
          }
          if (document.hidden) return;

          const activeIndex = switches.findIndex((control) => control.getAttribute('aria-checked') === 'true');
          const nextControl = switches[(activeIndex + 1) % switches.length];
          activate(nextControl.dataset.portfolioSwitch);
        }, 5000);
      }
    };

    document.querySelectorAll('[data-portfolio-switcher]').forEach(mountPortfolioSwitcher);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-portfolio-switcher]').forEach(mountPortfolioSwitcher);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-portfolio-switcher]').forEach((root) => {
        switcherCleanups.get(root)?.();
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const option = event.target.closest('[data-portfolio-option]');
      const root = event.target.closest('[data-portfolio-switcher]');
      if (!option || !root) return;

      const control = root.querySelector(`[data-portfolio-switch="${option.dataset.portfolioOption}"]`);
      if (control) control.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickr-product-native"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tickr-native-product')) {
    customElements.define('tickr-native-product', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
        this.stage = this.querySelector('.tickr-native-product__stage');
        this.swipeStart = null;
        this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (this.index < 0) this.index = 0;
        this.querySelectorAll('[data-gallery-step]').forEach((button) => {
          button.addEventListener('click', () => this.showSlide(this.index + Number(button.dataset.galleryStep)));
        });
        this.thumbnails.forEach((button) => {
          button.addEventListener('click', () => this.showSlide(Number(button.dataset.galleryThumbnail)));
        });
        this.querySelectorAll('[data-variant-choice]').forEach((input) => {
          input.addEventListener('change', () => this.updateVariant(input));
        });
        if (this.stage) {
          this.stage.addEventListener('pointerdown', (event) => this.startSwipe(event));
          this.stage.addEventListener('pointerup', (event) => this.finishSwipe(event));
          this.stage.addEventListener('pointercancel', (event) => this.cancelSwipe(event));
          this.stage.addEventListener('dragstart', (event) => event.preventDefault());
        }
      }

      showSlide(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.thumbnails.forEach((thumbnail) => {
          const active = Number(thumbnail.dataset.galleryThumbnail) === this.index;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', String(active));
        });
        const activeSlide = this.slides[this.index];
        activeSlide.classList.remove('is-entering');
        void activeSlide.offsetWidth;
        activeSlide.classList.add('is-entering');
      }

      startSwipe(event) {
        if (event.button !== 0) return;
        this.swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stage.classList.add('is-dragging');
        this.stage.setPointerCapture(event.pointerId);
      }

      finishSwipe(event) {
        if (!this.swipeStart || event.pointerId !== this.swipeStart.id) return;
        const distanceX = event.clientX - this.swipeStart.x;
        const distanceY = event.clientY - this.swipeStart.y;
        this.cancelSwipe(event);
        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        this.showSlide(this.index + (distanceX < 0 ? 1 : -1));
      }

      cancelSwipe(event) {
        if (!this.swipeStart || event.pointerId !== this.swipeStart.id) return;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        this.swipeStart = null;
        this.stage.classList.remove('is-dragging');
      }

      updateVariant(input) {
        const idInput = this.querySelector('[data-variant-id]');
        const addButton = this.querySelector('[data-add-button]');
        const addLabel = this.querySelector('[data-add-label]');
        const price = this.querySelector('[data-product-price]');
        const compare = this.querySelector('[data-product-compare]');
        const saving = this.querySelector('[data-product-saving]');
        const savingsPercentage = this.querySelector('[data-savings-percentage]');
        const available = input.dataset.available === 'true';
        const savings = Number(input.dataset.savings || 0);
        idInput.value = input.dataset.variantId;
        price.textContent = input.dataset.price;
        compare.textContent = input.dataset.comparePrice;
        compare.hidden = !input.dataset.comparePrice;
        saving.setAttribute('aria-hidden', String(savings <= 0));
        savingsPercentage.textContent = savings + '%';
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.availableLabel || 'Add to cart' : addButton.dataset.soldOutLabel || 'Sold Out';
        if (input.dataset.mediaId) {
          const mediaIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === input.dataset.mediaId);
          if (mediaIndex >= 0) this.showSlide(mediaIndex);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.dataset.variantId);
        window.history.replaceState({}, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
